import React, { FC } from 'react';
import useSitecoreContext from '../../../../hooks/useSitecoreContext';
import Picture from '../../../@shared/picture';
import { TEditorialImageProps } from '../../../@shared/picture/types/editorialImage.types';
import { TEventsListingMedia } from '../../types/eventsListing.types';

const Media: FC<TEventsListingMedia> = (props) => {
  const { desktopImage, mobileImage, isDesktop } = props;
  const { sitecoreContext = {} } = useSitecoreContext();
  const desktopDefaultImageUrl = sitecoreContext?.defaultBackgroundImageParameters?.desktopImageData?.eventsListingCardImage;
  const mobileDefaultImageUrl = sitecoreContext?.defaultBackgroundImageParameters?.mobileImageData?.eventsListingCardImage;

  const shouldShowDefaultImage = !desktopImage?.value?.src && !mobileImage?.value?.src;

  const editorialProps: TEditorialImageProps = {
    mobileImage: mobileImage,
    desktopImage: desktopImage,
    mobileTransformation: 'Size500',
    desktopTransformation: 'Size1000',
    alt: (isDesktop ? desktopImage?.value?.alt : mobileImage?.value?.alt) as string,
  };

  if (shouldShowDefaultImage) {
    editorialProps['mobileImage'] = mobileDefaultImageUrl ? { value: { src: mobileDefaultImageUrl } } : undefined;
    editorialProps['desktopImage'] = desktopDefaultImageUrl ? { value: { src: desktopDefaultImageUrl } } : undefined;
  }

  return <Picture editorialImageProps={editorialProps} />;
};

export default Media;
